// extracted by mini-css-extract-plugin
module.exports = {"component":"sideBarListComponent_component__2db86"};